import React from 'react';
import { defaultProps, withProps } from '@team-griffin/rehook';
import pureEnhance from '@ux/pure-enhance';
import ReactiveButton, { Kind as Kind$1, Size as Size$1, Against as Against$1, Status } from '@ux/reactive-button';
import { anyPass, both, propEq, pathEq, omit } from 'ramda';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var Kind = Kind$1;
var Size = Size$1;
var Against = Against$1; // We only want the button to unclickable when a field level validation problem
// has occured. If it was a submit level error (outside of validation) then
// the submit button should still be useable

var getStatus = function getStatus(props) {
  var _props$formProps = props.formProps,
      asyncValidating = _props$formProps.asyncValidating,
      submitting = _props$formProps.submitting,
      submitSucceeded = _props$formProps.submitSucceeded,
      submitFailed = _props$formProps.submitFailed;

  if (submitting === true || asyncValidating === true) {
    return Status.PENDING;
  }

  if (submitSucceeded === true) {
    return Status.SUCCESS;
  }

  if (submitFailed === true) {
    return Status.DEFAULT;
  } // Do not lockup of there is a general error
  // as this message could be used to give information about
  // why the form errored during a network error
  // if (error === true) {
  //   return Status.FAILURE;
  // }
  // if (invalid === true) {
  //   return Status.FAILURE;
  // }


  return Status.DEFAULT;
};

var isDisabled = anyPass([both(propEq('allowPristine', false), pathEq(['formProps', 'pristine'], true)), pathEq(['formProps', 'submitting'], true), pathEq(['formProps', 'asyncValidating'], true)]);

var PureSubmit = function PureSubmit(_a) {
  var theme = _a.theme,
      status = _a.status,
      disabled = _a.disabled,
      children = _a.children,
      rest = __rest(_a, ["theme", "status", "disabled", "children"]);

  return React.createElement(ReactiveButton, Object.assign({
    theme: theme,
    type: "submit",
    disabled: disabled,
    status: status
  }, omit(['formProps', 'allowPristine'], rest)), children);
};

var enhance = pureEnhance('Submit', [defaultProps({
  kind: Kind$1.PRIMARY,
  allowPristine: false
}), withProps(function (props) {
  return {
    status: getStatus(props),
    disabled: isDisabled(props)
  };
})]);
var Submit = enhance(PureSubmit); // eslint-disable-next-line no-underscore-dangle

export default Submit;
export { Against, Kind, Size };
